import CloseIcon from "@mui/icons-material/Close";
import { Box, Dialog, IconButton, Typography } from "@mui/material";
import { observer } from "mobx-react";
import { FC } from "react";

import { useStore } from "../../hooks";
import { IPopupProps } from "../../store/popup-store";
import Loader from "../loader/loader";
import styles from "./styles";

const Popup: FC<IPopupProps> = ({
  open,
  sx = {},
  size = "sm",
  onClose,
  title,
  children,
}) => {
  const { popupStore } = useStore();

  return (
    <Dialog
      open={open}
      onClose={onClose || undefined}
      closeAfterTransition
      scroll="body"
      maxWidth={size}
      sx={styles.dialog}
      PaperProps={{ sx: styles.paper, elevation: 0 }}
    >
      <Loader isLoading={popupStore.isLoading} />
      <Box sx={sx.paper || styles.content}>
        {onClose && (
          <IconButton sx={styles.close} onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        )}
        {title && (
          <Box>
            <Typography sx={styles.title}>{title}</Typography>
            <Box sx={styles.divider}>
              <svg width="100%" height="2px" xmlns="http://www.w3.org/2000/svg">
                <rect
                  width="100%"
                  height="2px"
                  style={{ fill: "none", stroke: "#E0E4EE", strokeWidth: 4, strokeDasharray: "1 10" }}
                />
              </svg>
            </Box>
          </Box>
        )}

        {children}
      </Box>
    </Dialog>
  );
};

export default observer(Popup);
